module.exports = __webpack_public_path__ + "static/img/store-label-address.c9fe233c.png";